import React from "react";

import { Button } from "antd";

import { ReactComponent as FilterCategoryIcon } from "../../../../assets/icons/Sample Submission Redesign/sound-module-line.svg";
import closeFilterIcon from "../../../../assets/images/product/lightBlueCancelIcon.png";

import "./SubmissionFilterButton.css";

const SubmissionFilterButton = ({
  specText,
  specSelected,
  disableFilterButton,
  handleToggleFilter,
  hideCloseIcon = false,
}) => {
  /**
   *Toggle filter button
   */
  const onToggleFilter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleToggleFilter();
  };

  return (
    <Button
    // disabled={disableFilterButton}
      type={specSelected ? "primary" : "text"}
      ghost={specSelected}
      htmlType="button"
      className={`${specSelected ? "SubmissionFilterButton__SpecSelected" : "SubmissionFilterButton__SpecNotSelected"} ${disableFilterButton ? "SubmissionFilterButton__Spec--disabled" : ""}`}
      onClick={(e) => onToggleFilter(e)}
    >
      {/* <div
          className="specCategoryIcon"
          style={{ backgroundColor: specColor }}
        /> */}
      <FilterCategoryIcon className="filterCategoryIcon" aria-hidden />
      <div className="filterStatusCategory">{specText}</div>
      {specSelected && !hideCloseIcon && (
      <img
        className="filterStatusCategoryCloseFilterIcon"
        src={closeFilterIcon}
        alt="closeFilterIcon"
        width="14px"
      />
      )}
    </Button>
  );
};

export default SubmissionFilterButton;
